import React, { useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { withStyles } from "@mui/styles";
import { format } from "date-fns";

import { withState } from "../../../services/state";

import { getEvent as apiGetEvent } from "../../../services/api";

import PageWrapper from "../../components/pageWrapper/PageWrapper";
import Section from "../../components/section/Section";
import Label from "../../components/label/Label";

import EventPlayersTable from "../../tables/eventPlayersTable/EventPlayersTable";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  detail: {
    marginBottom: 20,
  },
});

function EventPage({ classes, dispatch, context }) {
  const { eventId } = useParams();

  const [gettingEvent, setGettingEvent] = React.useState(true);
  const [event, setEvent] = React.useState({});

  const getEvent = useCallback(async () => {
    try {
      setGettingEvent(true);
      const data = await apiGetEvent(eventId);
      if (data && !data.reason) {
        setEvent(data);
      }
      setGettingEvent(false);
    } catch (e) {
      console.log(e);
      setGettingEvent(false);
    }
  }, [eventId]);

  useEffect(() => {
    getEvent();
  }, [getEvent]);

  return (
    <PageWrapper
      showHeader={true}
      showSidebar={true}
      title="Event"
      showLoading={gettingEvent}
    >
      <Section>
        {event && event.type && event.team && (
          <div>
            <div className={classes.detail}>
              <Label title="NAME" />
              <div>{event.name}</div>
            </div>
            <div className={classes.detail}>
              <Label title="EVENT DATE" />
              <div>{format(new Date(event.eventDate), "do MMMM yyyy")}</div>
            </div>
            <div className={classes.detail}>
              <Label title="EVENT TYPE" />
              <div>{event.type.name}</div>
            </div>
            <div className={classes.detail}>
              <Label title="TEAM" />
              <div>{event.team.name}</div>
            </div>
          </div>
        )}
      </Section>

      <Section>
        <EventPlayersTable
          players={event.players}
          isTreasurerOrCaptain={
            context.currentClub.isTreasurer ||
            (event && event.isCaptainForEventTeam)
          }
          myPlayer={context.currentPlayer}
        />
      </Section>
    </PageWrapper>
  );
}

export default withStyles(styles)(withState(EventPage));
